<sm-title-bar pageTitle="Booking Details" [back]="true"> </sm-title-bar>

<div class="member_details_view" *ngIf="!loader && bookingsData.length > 0">
  <div class="container">
    <div class="row">
      <div class="col-sm-8 mobile-pnloyet">
        <!-- <div class="alert_number_tt">
    <p>
      <mat-icon>error</mat-icon>
      The user associated with this member's phone number declined the membership.
    </p>
    <p class="re_port">Re-check the phone number or change with the latest number of the member. </p>
  </div> -->

        <div class="salon_mei_section">
          <mat-card appearance="outlined">
            <div class="exert_opd">
              <div class="opert_section">
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu"
                  class="more-button"
                  aria-label="More options"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 0 ||
                        bookingsData[0].bookingStatus == 1 ||
                        bookingsData[0].bookingStatus == 2) &&
                      bookingsData[0].customerInfo.hash_id &&
                      bookingsData[0].customerInfo.hash_id != 'null' &&
                      isOwner
                    "
                    (click)="confirmBooking(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined"
                      >check_circle</mat-icon
                    >
                    <span>{{
                      "business_bookings.opt_confirm_booking" | translate
                    }}</span>
                  </button>
                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 0 ||
                        bookingsData[0].bookingStatus == 1 ||
                        bookingsData[0].bookingStatus == 2 ||
                        bookingsData[0].bookingStatus == 7 ||
                        bookingsData[0].bookingStatus == 9 ||
                        bookingsData[0].bookingStatus == 5) &&
                      isfuture == false
                    "
                    (click)="startProcess(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">timer</mat-icon>
                    <!-- RESTRICTED -->
                    <span>{{
                      "business_bookings.opt_start_process" | translate
                    }}</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 0 ||
                        bookingsData[0].bookingStatus == 1 ||
                        bookingsData[0].bookingStatus == 2 ||
                        bookingsData[0].bookingStatus == 7 ||
                        bookingsData[0].bookingStatus == 9 ||
                        bookingsData[0].bookingStatus == 5) &&
                      isOwner &&
                      isfuture == false
                    "
                    (click)="assignJob(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined"
                      >assignment_ind</mat-icon
                    >

                    <span>{{
                      "business_bookings.opt_assign_job" | translate
                    }}</span>
                  </button>

                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 3 ||
                        bookingsData[0].bookingStatus == 5) &&
                      isfuture == false
                    "
                    (click)="done(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined"
                      >task_alt</mat-icon
                    >
                    <!-- RESTRICTED -->
                    <span>{{ "business_bookings.opt_done" | translate }}</span>
                  </button>

               

                  <button
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 3 ||
                        bookingsData[0].bookingStatus == 9 ||
                        bookingsData[0].bookingStatus == 4) &&
                      isOwner &&
                      isfuture == false
                    "
                    (click)="customiseBooking(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">tune</mat-icon>
                    <span>Edit data</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      bookingsData[0].bookingStatus != 4 &&
                      bookingsData[0].bookingStatus != 6 &&
                      bookingsData[0].bookingStatus != 8 &&
                      bookingsData[0].bookingType == '2'
                    "
                    (click)="addEditMeetingData(bookingsData[0])"
                  >
                    <!-- RESTRICTED (open in view mode only for EMPLOYEES)-->
                    <mat-icon class="material-icons-outlined"
                      >video_chat</mat-icon
                    >
                    <span>Meeting info</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 3 ||
                        bookingsData[0].bookingStatus == 9 ||
                        bookingsData[0].bookingStatus == 4 ||
                        bookingsData[0].bookingStatus == 7) &&
                      isOwner &&
                      isfuture == false
                    "
                    (click)="reset(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined"
                      >restart_alt</mat-icon
                    >
                    <span>{{
                      "business_bookings.opt_reset_to_new" | translate
                    }}</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      bookingsData[0].bookingStatus == 4 && isfuture == false
                    "
                    (click)="opentorate(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">share</mat-icon>
                    <span>Share details to rate</span>
                  </button>
                     <!-- <button mat-menu-item (click)="servicereminder()" [disabled]="!getAccessStatus()">
                    <mat-icon class="material-icons-outlined">notification_add</mat-icon>
                    <span>Set auto reminder</span>
                  </button> -->
                  <button
                  [disabled]="!getAccessStatus()"
                    mat-menu-item
                    *ngIf="
                      bookingsData[0].bookingStatus == 4 || (isAdvance() && (bookingsData[0].bookingStatus != 6 && bookingsData[0].bookingStatus != 8))
                    "
                    (click)="openInvoice(bookingsData[0])"
                  >
                    <!-- RESTRICTED -->
                    <mat-icon class="material-icons-outlined"
                      >receipt_long</mat-icon
                    >
                    <span>{{
                      "business_bookings.opt_invoice" | translate
                    }}</span>
                  </button>
                  <button
                    mat-menu-item
                    *ngIf="
                      (bookingsData[0].bookingStatus == 0 ||
                        bookingsData[0].bookingStatus == 1 ||
                        bookingsData[0].bookingStatus == 2 ||
                        bookingsData[0].bookingStatus == 5) &&
                      isOwner
                    "
                    (click)="cancelBooking(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">cancel</mat-icon>
                    <span>{{
                      "business_bookings.opt_cancel_booking" | translate
                    }}</span>
                  </button>
                  <!-- restrict DELETE if online payment done by customer (CHECK LOGIC)-->
                  <button
                    mat-menu-item
                    
                    (click)="deleteBooking(bookingsData[0])"
                     [disabled]="isDeleteDisabled(bookingsData[0])"
                  >
                    <mat-icon class="material-icons-outlined">delete</mat-icon>
                    <span>Delete booking</span>
                  </button>
                </mat-menu>
              </div>

              <div class="booking_flex_one">
                <div class="salon_img_member">
                  <img
                  (click)="viewdetails(bookingsData[0])"
                    style="cursor: pointer;"
                    [src]="bookingsData[0].customerInfo.imgThumbUrl"
                    onerror="this.src='../../../../assets/images/user-avatar.svg'"
                    alt=""
                  />
                </div>
                <div class="hair_ct_heading">
                  <div class="rahul_headert">
                    <h4 class="h4_hyper" (click)="viewdetails(bookingsData[0])">{{ bookingsData[0].customerName }}</h4>
                    <p>
                      {{ bookingsData[0].country_code }}
                      {{ bookingsData[0].customerPhone }}
                    </p>

                    <p class="created_on_heading">
                      Created on: {{ bookingsData[0].creationDate | date }}
                    </p>
                  </div>
                </div>
              </div>

              <div class="active_cardt">
                <p>
                  <span
                    class="status"
                    [class.new-booking]="
                      bookingsData[0].bookingStatus == 0 ||
                      bookingsData[0].bookingStatus == 1 ||
                      bookingsData[0].bookingStatus == 2
                    "
                    [class.under-process]="
                      bookingsData[0].bookingStatus == 3 ||
                      bookingsData[0].bookingStatus == 7 ||
                      bookingsData[0].bookingStatus == 9
                    "
                    [class.completed]="bookingsData[0].bookingStatus == 4"
                    [class.cancelled]="
                      bookingsData[0].bookingStatus == 6 ||
                      bookingsData[0].bookingStatus == 8
                    "
                    [class.confirmed]="bookingsData[0].bookingStatus == 5"
                  ></span>
                  <span class="booking_data_left" style="color: #222;">
                    {{ bookingsData[0].bookingStat }}</span
                  >
                </p>
                <div *ngIf="bookingsData[0].payments" style="margin-top: 5px;">
                  <p *ngFor="let item of bookingsData[0].payments">
                    
                    <span class="">
                       {{
                                      item.refund_status === 0
                                        ? "Payment status: Complete"
                                        : "Refund status: " +
                                          (item.refund_status === 1
                                            ? "Initiated"
                                            : item.refund_status === 2
                                            ? "Processed"
                                            : item.refund_status === 3
                                            ? "Failed"
                                            : "Unknown")
                                    }}, Mode: {{ item.payment_mode }},
                                    Amount: {{ item.amount | currency: bookingsData[0].currency_symbol : 'symbol' : '1.2-2' }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </mat-card>
        </div>

        <div class="right_deatils_pp statts">
          <div class="service_info">
            <div class="member_det_og">
              <div
                class="service_listh"
                style="border: none; display: inline !important"
              >
                <div class="booking-card">
                  <div class="booking-badge">
                    {{ bookingsData[0].appointment_no }}
                  </div>
                  <div class="booking-info">
                    <!-- <h3>
      Status:
      <span class="status" [class.new-booking]="bookingsData[0].bookingStatus == 0 ||bookingsData[0].bookingStatus == 1 || bookingsData[0].bookingStatus == 2" [class.under-process]="bookingsData[0].bookingStatus == 3 || bookingsData[0].bookingStatus == 7 || bookingsData[0].bookingStatus == 9" [class.completed]="bookingsData[0].bookingStatus == 4" [class.cancelled]="bookingsData[0].bookingStatus == 6 || bookingsData[0].bookingStatus == 8" [class.confirmed]="bookingsData[0].bookingStatus == 5">{{bookingsData[0].bookingStat}}</span>
    </h3> -->
                    <h4 class="booking_listx">
                      Booking no:
                      <span class="pending">
                        {{ bookingsData[0].appointment_no }}</span
                      >
                    </h4>
                    <p class="booking_listx">
                      Booking type: {{ bookingsData[0].bType }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 5px">Slot info</h1>
          </div>
          <div class="slot_info_gt">
            <div class="solt_datef" style="margin-right: 12px">
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary">{{
                  bookingsData[0].bookingDate | date
                }}</mat-chip>
              </mat-chip-list>
            </div>
            <div class="solt_datef active_chip">
              <mat-chip-list aria-label="service mode">
                <mat-chip selected color="primary"
                  >{{ bookingsData[0].bookingStartTime }} -
                  {{ bookingsData[0].bookingEndTime }}</mat-chip
                >
              </mat-chip-list>
            </div>
          </div>
        </div>

        <div
          class="coupon_applied"
          *ngIf="
            bookingsData[0].coupon_code &&
            bookingsData[0].coupon_code != '' &&
            bookingsData[0].coupon_code != 'null'
          "
        >
          <mat-card appearance="outlined">
            <div class="coupon-card">
              <h3>Coupon applied</h3>
              <div class="coupon-row">
                <span id="cpnCode">{{ bookingsData[0].coupon_code }}</span>
                <!-- <span id="cpnBtn">Copy Code</span> -->
              </div>
              <div class="circle1"></div>
              <div class="circle2"></div>
            </div>
          </mat-card>
        </div>

        <div class="right_deatils_pp">
          <!-- Opted services -->
          <div class="sub_ser">
            <h3 class="sub_headingt">Opted services</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of bookingsData[0].serviceInfo"
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="item.imgUrl && item.imgUrl != 'null'"
                    >
                      <img
                        [src]="item.imgUrl"
                        onerror="this.src='../../../../assets/images/photo.png'"
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="!item.imgUrl || item.imgUrl == 'null'"
                    >
                      <p>{{ item.serviceName.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.serviceName }} X {{ item.qty }}
                      </h4>
                      <p>
                        {{ bookingsData[0].currency_symbol
                        }}{{ item.rate.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Opted products -->
          <div class="sub_ser" *ngIf="bookingsData[0].appointment_products">
            <h3 class="sub_headingt">Opted products</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of bookingsData[0].appointment_products"
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="
                        item.product_img_url && item.product_img_url != 'null'
                      "
                    >
                      <img
                        [src]="item.product_img_url"
                        onerror="this.src='../../../../assets/images/photo.png'"
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="
                        !item.product_img_url || item.product_img_url == 'null'
                      "
                    >
                      <p>{{ item.product_name.slice(0, 1).toUpperCase() }}</p>
                    </div>

                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.product_name }} X {{ item.product_qty }}
                      </h4>
                      <p>
                        {{ bookingsData[0].currency_symbol
                        }}{{ item.product_price.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Other items -->
          <div class="sub_ser" *ngIf="bookingsData[0].custom_items">
            <h3 class="sub_headingt">Other items</h3>
            <div class="service_mode_chip">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of bookingsData[0].custom_items"
                >
                  <div class="service_listh">
                    <div class="placeholder_headingv">
                      <p>{{ item.item_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.item_name }} X {{ item.item_qty }}
                      </h4>
                      <p>
                        {{ bookingsData[0].currency_symbol
                        }}{{ item.item_price.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 6px">Notes</h1>
          </div>
          <div class="member_paragr">
            <p>
              {{
                bookingsData[0].note && bookingsData[0].note != "null"
                  ? bookingsData[0].note
                  : "No notes added"
              }}.
            </p>
          </div>
        </div>
      </div>

      <div class="col-sm-4 bookingrt">
        <div
          class="trainer_start"
          *ngIf="
            bookingsData[0].employeeName &&
            bookingsData[0].employeeName != '---' &&
            bookingsData[0].employeeName != ''
          "
        >
          <mat-card appearance="outlined">
            <div class="main_headingrt">
              <h1>Assigned to</h1>
            </div>
            <div class="trainer_list">
              <div class="trainer_img">
                <img
                  [src]="bookingsData[0].employee_thumb_url"
                  onerror="this.src='../../../../assets/images/user-avatar.svg'"
                  alt=""
                />
              </div>
              <div class="trainer_heading">
                <h3>{{ bookingsData[0].employeeName }}</h3>
                <p
                  *ngIf="
                    bookingsData[0].bookingStatus != 4 &&
                    bookingsData[0].employeeName &&
                    bookingsData[0].employeeName != '---'
                  "
                >
                  Last update:
                  {{
                    bookingsData[0].updateStatusDate | date : "MMM d, y, h:mm a"
                  }}
                </p>
                <p *ngIf="bookingsData[0].bookingStatus == 4">
                  Completed at:
                  {{
                    bookingsData[0].updateStatusDate | date : "MMM d, y, h:mm a"
                  }}
                </p>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="trainer_start"
          *ngIf="
            bookingsData[0].booking_address &&
            bookingsData[0].booking_address != 'null' &&
            bookingsData[0].booking_address != ''
          "
        >
          <mat-card appearance="outlined" class="addewsas" style="padding-bottom: 8px;">
            <div class="main_headingrt ">
              <h1 style="margin-bottom: 2px;">Booking address</h1>
            </div>
             <p
                  style="white-space: pre-line; margin-bottom: 5px;color: #888;"
                  *ngIf="
                    bookingsData[0].booking_address.house_no ||
                    bookingsData[0].booking_address.street_name
                  "
                >
                  <span *ngIf="bookingsData[0].booking_address.house_no">{{
                    bookingsData[0].booking_address.house_no
                  }}, </span
                  >
                  <span *ngIf="bookingsData[0].booking_address.street_name">{{
                    bookingsData[0].booking_address.street_name
                  }}</span>
                </p>
                <p style="white-space: pre-line; margin-bottom: 5px;color: #888;">
                  {{ bookingsData[0].booking_address.city }},
                  {{ bookingsData[0].booking_address.state }},
                  PIN/ZIP: {{bookingsData[0].booking_address.zip}}

                </p>
                <p style="white-space: pre-line; margin-bottom: 5px;color: #888;">
                  {{ bookingsData[0].booking_address.address_line }}
                </p>
                <p
                  style="white-space: pre-line; margin-bottom: 5px;color: #888;"
                  *ngIf="bookingsData[0].booking_address.landmark"
                >
                  Landmark: {{ bookingsData[0].booking_address.landmark }}
                </p>
                <p *ngIf="bookingsData[0].booking_address.phone" style="white-space: pre-line; margin-bottom: 5px;color: #888;">
                Contact phone:  {{bookingsData[0].booking_address.country_code}} {{bookingsData[0].booking_address.phone}}
                </p>

                <div class="flex_uner_flex" (click)="openGoogleMaps(bookingsData[0].booking_address)">
                  <div class="view_on_map_btn">
                      <p>View on map</p>
                  </div>
                      <div class="arrow_map_icon">
                          <mat-icon>arrow_forward</mat-icon>
                      </div>
                </div>
          </mat-card>
        </div>

        <!-- Subscription fees -->
        <div class="order_summary_section">
          <mat-card appearance="outlined">
            <div class="booking_name_opop">
              <h1 style="margin-bottom: 20px">Fees and payment</h1>
            </div>
            <div class="shop_flexc">
              <div class="clrt_heading">Service cost</div>
              <div>
                {{ bookingsData[0].currency_symbol
                }}{{ bookingsData[0].price.toFixed(2) }}
              </div>
            </div>
            <div
              class="shop_flexc"
              *ngIf="
                bookingsData[0].discount &&
                bookingsData[0].discount != 0
              "
            >
              <div class="clrt_heading">Discount</div>
              <div class="price_oper">
                {{
                  bookingsData[0].currency_symbol
                    ? bookingsData[0].currency_symbol
                    : "₹"
                }}{{ bookingsData[0].discount.toFixed(2) }}
              </div>
            </div>
            <div
              class="shop_flexc"
              *ngIf="
                bookingsData[0].coupon_discount &&
                bookingsData[0].coupon_discount != 0 &&
                bookingsData[0].coupon_discount != '0'
              "
            >
              <div class="clrt_heading">Coupon discount</div>
              <div>
                {{ bookingsData[0].currency_symbol
                }}{{ (+bookingsData[0].coupon_discount).toFixed(2) }}
              </div>
            </div>

            <div
              class="shop_flexc"
              *ngIf="
                bookingsData[0].paymentStatus &&
                bookingsData[0].paymentStatus != 0
              "
            >
              <div class="clrt_heading">Payment amount</div>
              <div class="price_oper">
                {{
                  bookingsData[0].currency_symbol
                    ? bookingsData[0].currency_symbol
                    : "₹"
                }}{{ bookingsData[0].customerPayment.toFixed(2) }}
              </div>
            </div>
            
            <!-- <div
              class="shop_flexc"
              *ngIf="
                bookingsData[0].paymentStatus &&
                bookingsData[0].paymentStatus != 0
              "
            >
              <div class="clrt_heading">Payment due</div>
              <div class="price_oper">
                {{
                  bookingsData[0].currency_symbol
                    ? bookingsData[0].currency_symbol
                    : "₹"
                }}{{ bookingsData[0].payment_due.toFixed(2) }}
              </div>
            </div> -->
            <!-- <div class="shop_flexc">
              <div class="clrt_heading">Payment status</div>
              <div>{{ bookingsData[0].paymentStat }}</div>
            </div> -->

            <!-- <div
              class="shop_flexc"
              *ngIf="
                bookingsData[0].paymentStatus &&
                bookingsData[0].paymentStatus != 0
              "
            >
              <div class="clrt_heading">Payment mode</div>
              <div class="price_oper">{{ bookingsData[0].paymentMode }}</div>
            </div> -->
            <div class="shop_flex servi_border">
              <div class="texhesdingt">
                * Taxes and other charges may apply.
              </div>
            </div>
          </mat-card>
        </div>

        <div class="booking_detail_info">
          <p>{{ bookingsData[0].entityInfo.name }}</p>
          <p class="address_frt">{{ bookingsData[0].entityInfo.address }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
